import * as v from 'valibot'

export const NovelAdminMediaKind = v.picklist(['speech', 'opening_speech', 'drama_video'])
const Hash = v.pipe(v.string(), v.regex(/^[a-f0-9]{64}$/))
const FilterId = v.pipe(v.string(), v.trim(), v.minLength(1), v.maxLength(64))
const Count = v.pipe(v.number(), v.integer(), v.minValue(0))
const OptionalText = v.nullable(v.string())

export const NovelAdminMediaListQuery = v.strictObject({
  kind: v.optional(NovelAdminMediaKind),
  pack_id: v.optional(FilterId),
  run_id: v.optional(FilterId),
  user_id: v.optional(FilterId),
  limit: v.optional(v.pipe(v.string(), v.regex(/^[1-9]\d{0,2}$/), v.transform(Number), v.maxValue(100)), '20'),
  offset: v.optional(v.pipe(v.string(), v.regex(/^\d{1,8}$/), v.transform(Number)), '0'),
})

/** Saved object metadata only; authenticated content is delivered separately on explicit preview. */
export const NovelAdminMediaList = v.object({
  items: v.array(v.object({
    asset_id: Hash,
    kind: NovelAdminMediaKind,
    provider: v.nullable(v.picklist(['vidu', 'vivix'])),
    pack_id: v.string(),
    pack_title: v.string(),
    user_id: OptionalText,
    user_name: OptionalText,
    run_id: OptionalText,
    segment_id: OptionalText,
    request_id: OptionalText,
    voice_id: OptionalText,
    tts_call_id: OptionalText,
    session_id: OptionalText,
    play_language: v.string(),
    created_at: v.string(),
    mime: v.picklist(['audio/mpeg', 'video/webm', 'video/mp4']),
    bytes: v.pipe(Count, v.minValue(1)),
    duration_ms: v.nullable(v.pipe(Count, v.minValue(1))),
  })),
  total: Count,
  limit: v.pipe(Count, v.minValue(1), v.maxValue(100)),
  offset: Count,
})
